import { useEffect, useState } from 'react'

const STORAGE_KEY = 'dev:legacyQuoteUI'

const readStoredValue = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const useDevLegacyQuoteUI = (): [boolean, (next: boolean) => void] => {
  const [value, setValue] = useState<boolean>(readStoredValue)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setValue(e.newValue === 'true')
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const update = (next: boolean) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch {
      void 0
    }
    setValue(next)
  }

  return [value, update]
}
